import { createSlice,createAsyncThunk  } from "@reduxjs/toolkit";
import { httpService } from "../../../services/httpService";

// 🔹 Thunk to fetch from API
export const fetchAppointments = createAsyncThunk(
 'appointments/fetchAppointments',
 async () => {
          const response = await httpService.get(`/appointment/getAppoinments`);
   return response.data;
 }
);

const appointmentSlice = createSlice({
  name: "appointments",
  initialState: {
    list: [],
    isDraggingEvent: false,
    draggedAppointment: null, // 🔸 ADD THIS
  },
  reducers: {
    addAppointment: (state, action) => {
      state.list = [...state.list, action.payload];
    },
    updateAppointment: (state, action) => {
      const updated = action.payload;
      const index = state.list.findIndex((a) => a.id === updated.id);
      if (index !== -1) {
        state.list[index] = updated;
        state.list = [...state.list]; // 🔸 re-render
      }
    },
    deleteAppointment: (state, action) => {
      const idToDelete = action.payload;
      state.list = state.list.filter((a) => a.id !== idToDelete);
    },
    setIsDraggingEvent: (state, action) => {
      state.isDraggingEvent = action.payload;
    },
    setDraggedAppointment: (state, action) => {
      state.draggedAppointment = action.payload; // 🔸 NEW
    },
    updateEventTime: (state, action) => {
      const { id, changes } = action.payload;
      const index = state.list.findIndex(event => event.id === id);
      if (index !== -1) {
        state.list[index] = { ...state.list[index], ...changes };
        state.list = [...state.list]; // 🔸 re-render
      }
    }
  },

  extraReducers: (builder) => {
builder
.addCase(fetchAppointments.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchAppointments.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchAppointments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
}
});

// ✅ Be sure to EXPORT the new reducer
export const {
  addAppointment,
  updateAppointment,
  deleteAppointment,
  setIsDraggingEvent,
  setDraggedAppointment, // 🔸 ADD THIS
  updateEventTime
} = appointmentSlice.actions;

export default appointmentSlice.reducer;